// src/belediye/components/notifications/PushKurulumPaneli.js
//
// FAZ-84 — TELEFON BİLDİRİMİ: BU CİHAZIN DURUMU
//
// Yalnızca "bu cihaz kurulu mu, değilse sıradaki adım ne" sorusunu cevaplar.
// Kişinin tercih anahtarları (telefon bildirimi açık/kapalı, sessiz saat)
// SettingsModal'da, diğer ayarlarla AYNI satır dilinde durur — bu bileşen
// onları çizmez.
//
// TASARIM KARARI (2026-08-01, kullanıcı: "şu anki hali güzel değil, mantıklı
// bir tasarım haline getirelim"): ilk sürümde bu panel kendi çerçeveli kartıydı
// ve pencerenin geri kalanıyla aynı dili konuşmuyordu — ayarlar listesinin
// ortasına yapıştırılmış yabancı bir kutu gibi duruyordu. Artık kart yok:
// bileşen, ayarların kendi `.sm-*` diliyle çizilen ince bir durum bloğu.
//
// TEST BİLDİRİMİ DÜĞMESİ KALDIRILDI (kullanıcı: "kişiler için test bildirimi
// falan olmasın, gerekmez"). Kişi zaten açtığı anda ilk gerçek bildirimde
// çalıştığını görüyor.
//
// Durum → gösterilen (SIRA ÖNEMLİ, FAZ-100):
//   sunucuda kapalı / yükleniyor    → hiç çizilmez
//   iPhone + ana ekranda DEĞİL      → 4 adımlı "Ana Ekrana Ekle" anlatımı  ⟵ ÖNCE
//                                     (+ Safari dışı tarayıcıysa uyarı)
//   tarayıcı desteklemiyor          → tek satır bilgi                      ⟵ SONRA
//   izin REDDEDİLMİŞ                → telefon ayarlarından açma yolu
//   izin yok / abonelik yok         → tek düğme
//   abonelik VAR                    → "bu cihazda açık" + kapatma bağlantısı
//
// İlk iki maddenin sırası bir üslup tercihi DEĞİLDİR; ters sırada iPhone'da
// özellik tümden ölüyordu (aşağıdaki FAZ-100 açıklamasına bakın).
import React, { useCallback, useEffect, useState } from "react";

import {
  destekVar,
  durumOku,
  kopukMu,
  kurulumBaslat,
  kurulumDinle,
  kurulumPenceresiVar,
  pushAc,
  pushKapat,
  pushOnar,
} from "../../services/pushIstemci";
import "./PushKurulumPaneli.css";

const bosDurum = {
  destek: false,
  standalone: false,
  platform: "masaustu",
  iosBaskaTarayici: false,
  izin: "default",
  abone: false,
  sunucuAktif: false,
};

export default function PushKurulumPaneli() {
  const [durum, setDurum] = useState(bosDurum);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [mesaj, setMesaj] = useState({ tur: "", metin: "" });
  const [islemde, setIslemde] = useState(false);
  const [kurulabilir, setKurulabilir] = useState(kurulumPenceresiVar());

  const tazele = useCallback(async () => {
    try {
      setDurum(await durumOku());
    } catch (_) {
      setDurum(bosDurum);
    } finally {
      setYukleniyor(false);
    }
  }, []);

  useEffect(() => {
    tazele();
  }, [tazele]);

  // Chrome kurulabilirlik olayını geç gönderebilir; bileşen dinler.
  useEffect(() => kurulumDinle(setKurulabilir), []);

  const kur = async () => {
    setIslemde(true);
    const sonuc = await kurulumBaslat();
    setIslemde(false);
    if (sonuc === "yok") setKurulabilir(false);
    tazele();
  };

  const ac = async () => {
    setIslemde(true);
    setMesaj({ tur: "", metin: "" });
    const sonuc = await pushAc();
    setIslemde(false);
    setMesaj(
      sonuc.ok
        ? { tur: "ok", metin: "Bu cihaz için etkinleştirildi." }
        : { tur: "hata", metin: sonuc.hata }
    );
    tazele();
  };

  const onar = async () => {
    setIslemde(true);
    setMesaj({ tur: "", metin: "" });
    const sonuc = await pushOnar();
    setIslemde(false);
    setMesaj(
      sonuc.ok
        ? { tur: "ok", metin: "Bağlantı yenilendi. Bildirimler yeniden iletilecektir." }
        : { tur: "hata", metin: sonuc.hata }
    );
    tazele();
  };

  const kapat = async () => {
    setIslemde(true);
    await pushKapat();
    setIslemde(false);
    setMesaj({ tur: "ok", metin: "Bu cihaz için kapatıldı." });
    tazele();
  };

  if (yukleniyor) return null;
  // Sunucuda anahtar yoksa özellik yokmuş gibi davran (kapalı-varsayılan).
  if (!durum.sunucuAktif) return null;

  const ios = durum.platform === "ios";
  const iosKurulumGerekli = ios && !durum.standalone;
  // Android'de (ve kurulabilir masaüstünde) kurulum bir ikramdır; yalnız henüz
  // kurulmamışsa teklif edilir.
  const telefonKurulumTeklifi =
    !ios && !durum.standalone && (durum.platform === "android" || kurulabilir);

  // ══════════════════════════════════════════════════════════════════════════
  // FAZ-100 — "DESTEKLEMİYOR" KAPISI ARTIK KURULUM ANLATIMINDAN SONRA.
  //
  // ÖNCEKİ HÂLİ, iPhone'da özelliği TÜMDEN ÖLDÜRÜYORDU. iOS'ta Push/Notification
  // API'leri Safari SEKMESİNDE tanımlı değildir; yalnız ana ekrana eklenmiş
  // uygulamanın içinde açılırlar. Yani kurulum yapmamış her iPhone kullanıcısı
  // için destekVar() FALSE dönüyor ve panel ilk satırda
  //   "Bu tarayıcı desteklemiyor, Safari ile açmayı deneyin"
  // yazıp duruyordu — kişi ZATEN Safari'deydi. Kurulum adımlarına ulaşmanın
  // yolu yoktu; kimse kuramıyordu, kimse abone olamıyordu, kimseye bildirim
  // gitmiyordu. (Kanıt: veritabanındaki tek abonelik masaüstü tarayıcıdan.)
  //
  // Doğru sıra: ÖNCE "bu cihazda ne yapman gerekiyor", SONRA gerçekten
  // desteklenmeyen ortam uyarısı. Platform tespiti user-agent'tan gelir, API'lerin
  // varlığına bağlı değildir — bu yüzden kurulmamış iPhone'da da doğru çalışır.
  // ══════════════════════════════════════════════════════════════════════════
  if (iosKurulumGerekli) {
    return (
      <div className="pkp">
        {durum.iosBaskaTarayici ? (
          <p className="pkp-uyari">
            iPhone’da telefon bildirimi <b>yalnız Safari</b> ile kurulabilir. Bu
            sayfayı Safari’de açın.
          </p>
        ) : null}
        <div className="pkp-adimlar">
          <div className="pkp-adimlar-baslik">
            iOS cihazlarda önce uygulamanın ana ekrana eklenmesi gerekir
          </div>
          <ol>
            <li>Bu sayfayı <b>Safari</b> tarayıcısı ile açınız.</li>
            <li>Alt çubuktaki <b>Paylaş</b> düğmesine dokunun (yukarı ok simgesi).</li>
            <li><b>“Ana Ekrana Ekle”</b> seçeneğini işaretleyin.</li>
            <li>Ana ekranda oluşan simgeden giriş yapıp bu ekrana dönün.</li>
          </ol>
          <p className="pkp-not">
            Bu bir iOS kısıtıdır: tarayıcı sekmesinde açık duran bir adres cihaza
            bildirim iletemez. Simgeden giriş yaptıktan sonra bu ekranda
            “Bildirimlere izin ver” düğmesi görüntülenecektir.
          </p>
        </div>
      </div>
    );
  }

  if (!destekVar()) {
    return (
      <p className="pkp-bilgi">
        Bu tarayıcı telefon bildirimlerini desteklememektedir. Cihazınızdan
        Safari (iOS) veya Chrome (Android) ile açmayı deneyiniz.
      </p>
    );
  }

  return (
    <div className="pkp">
      {/* İzin reddedilmiş → tarayıcı bir daha soramaz */}
      {durum.izin === "denied" ? (
        <p className="pkp-uyari">
          Bildirim izni daha önce <b>reddedilmiştir</b>. Tarayıcı izni yeniden
          talep edemez; cihaz ayarlarından etkinleştirmeniz gerekmektedir:{" "}
          {ios
            ? "Ayarlar → Bildirimler → Arsuz Çözüm Merkezi"
            : "Ayarlar → Uygulamalar → Arsuz Çözüm Merkezi → Bildirimler"}
          .
        </p>
      ) : null}

      {/* ══════════════════════════════════════════════════════════════════
          FAZ-101 — BAĞLANTI KOPMUŞ (tarayıcı "abone" diyor, sunucu tanımıyor)

          Kullanıcı sorusu: "kişi uygulamayı daha önceden yüklemiş, burada
          tekrardan silmesi veya yüklemesi gerekecek mi?"

          Cevap HAYIR olmalı — ve bu blok o cevabı mümkün kılan şeydir. Abonelik
          iki tarafta birden yaşar; sunucu tarafı ölmüş olabilir (uç 410 verdi,
          ortak telefonda başka personele devredildi, kayıt hiç ulaşmadı).
          Böyle bir durumda ekran şimdiye kadar "Açık" yazıyordu ve tek bildirim
          gelmiyordu; kişinin elinde kalan tek çare uygulamayı silip yeniden
          kurmaktı. Oysa gereken tek şey aboneliğin tazelenmesi — tek dokunuş.
          ══════════════════════════════════════════════════════════════════ */}
      {kopukMu(durum) ? (
        <div className="pkp-durum">
          <span className="pkp-rozet pkp-rozet-uyari">Bağlantı kopmuş</span>
          <span className="pkp-durum-metin">
            Cihaz kayıtlı görünmekte ancak sunucu bağlantısı kesilmiştir.
            Uygulamayı kaldırmanıza gerek yoktur.
          </span>
          <button
            type="button"
            className="btn-md btn-md-primary pkp-ac"
            onClick={onar}
            disabled={islemde}
          >
            Bağlantıyı yenile
          </button>
        </div>
      ) : null}

      {/* Durum satırı */}
      {!kopukMu(durum) && durum.abone ? (
        <div className="pkp-durum">
          <span className="pkp-rozet pkp-rozet-ok">Açık</span>
          <span className="pkp-durum-metin">Bu cihaza bildirim iletilmektedir.</span>
          <button
            type="button"
            className="sm-linkbtn"
            onClick={kapat}
            disabled={islemde}
          >
            Bu cihazda kapat
          </button>
        </div>
      ) : (
        <div className="pkp-durum">
          <span className="pkp-rozet">Kapalı</span>
          <button
            type="button"
            className="btn-md btn-md-primary pkp-ac"
            onClick={ac}
            /* iosKurulumGerekli burada ARANMAZ: o hâl yukarıda erken dönüşle
               karşılanıyor, buraya hiç düşmez. */
            disabled={islemde || durum.izin === "denied"}
          >
            {durum.izin === "granted"
              ? "Bu cihazda aç"
              : "Bildirimlere izin ver"}
          </button>
          {durum.izin !== "granted" ? (
            <p className="pkp-not">
              {/* FAZ-104: benzetme kaldırıldı, kurumsal dil. Söylenmesi gereken
                  tek şey birazdan ne olacağıdır — beklenmedik izin penceresi
                  reddedilmenin en yaygın sebebidir. */}
              Dokunduğunuzda cihazınız bildirim izni isteyecektir. Açılan
              pencerede <b>“İzin Ver”</b> seçeneğini onaylayınız.
            </p>
          ) : null}
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════════════
          FAZ-103 — ANDROID'DE KURULUM: ZORUNLU DEĞİL, İSTEĞE BAĞLI.

          Kullanıcı (2026-08-02): "bu sadece iPhone'a göre olmuş, bunu düzenle,
          Android'de de olsun."  Haklı — ama Android'e iPhone'un anlatımını
          kopyalamak da yanlış olurdu:

            • iOS'ta kurulum ZORUNLU ön koşuldur (API'ler ana ekrana eklenmeden
              yoktur) — bu yüzden orada blok en üstte ve tek iş odur.
            • Android'de bildirim sıradan bir tarayıcı sekmesinde de çalışır.
              Kurulum yalnızca simge ve okunmamış rozeti getirir.

          Bu yüzden burada blok, izin satırının ALTINDA ve "isteğe bağlı" diye
          etiketli. Sıra bir üslup tercihi değil; kişiye önce ZORUNLU olanı,
          sonra ikramı göstermek gerekir.
          ══════════════════════════════════════════════════════════════════ */}
      {telefonKurulumTeklifi ? (
        <div className="pkp-adimlar">
          <div className="pkp-adimlar-baslik">
            İsteğe bağlı: uygulamayı ana ekrana ekleme
          </div>
          <p className="pkp-not">
            Bildirimler tarayıcı üzerinden de iletilir; kurulum zorunlu değildir.
            Ana ekrana eklendiğinde uygulama simgeden doğrudan açılır ve simge
            üzerinde okunmamış bildirim sayınız görüntülenir.
          </p>
          {kurulabilir ? (
            <button
              type="button"
              className="btn-md pkp-ac"
              onClick={kur}
              disabled={islemde}
            >
              Ana ekrana ekle
            </button>
          ) : (
            <ol>
              <li>Sağ üst köşedeki <b>⋮</b> menüsüne dokunun.</li>
              <li>
                <b>“Uygulamayı yükle”</b> seçeneğini işaretleyin (bazı cihazlarda
                “Ana ekrana ekle” olarak görünür).
              </li>
            </ol>
          )}
        </div>
      ) : null}

      {mesaj.metin ? (
        <p className={`pkp-mesaj ${mesaj.tur === "hata" ? "hata" : "ok"}`}>
          {mesaj.metin}
        </p>
      ) : null}
    </div>
  );
}
